import LazyRoute from './LazyRoute'
import { withLazyLoadingScope } from './LazyRoute'

export { withLazyLoadingScope }
export default LazyRoute
